import type { ImageSize, ImageWithDataProps } from "./image-with-data.type";

import { useState } from "react";

import { useElementSize } from "@/utilities/element";

import { getOverlayStyle } from "./image-with-data.helper";

import "./image-with-data.style.less";

export const ImageWithData = ({ src, alt, data }: ImageWithDataProps) => {
  const [imageNaturalSize, setNaturalSize] = useState<ImageSize | null>(null);
  const { ref, size: containerSize } = useElementSize();

  const overlayStyle = getOverlayStyle({ containerSize, imageNaturalSize });

  return (
    <div ref={ref} className="image-with-data">
      <img
        src={src}
        alt={alt}
        className="image-with-data-image"
        onLoad={(e) => {
          const { naturalWidth, naturalHeight } = e.currentTarget;
          setNaturalSize({ width: naturalWidth, height: naturalHeight });
        }}
      />
      <div style={overlayStyle} className="image-with-data-overlay">
        {imageNaturalSize ? data : undefined}
      </div>
    </div>
  );
};
